import { FETCH_ALL, FETCH, START_LOADING, END_LOADING } from '../constants/actionTypes'
import * as api from '../api';

export const getHotspots = (page) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING });
        const { data } = await api.getHotspots(page);

        dispatch({ type: FETCH_ALL, payload: data});
        dispatch({ type: END_LOADING });
    } catch (error) {
        console.log(error);
        dispatch({ type: END_LOADING });
    }
}

export const getHotspot = (id) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING });
        const { data } = await api.getHotspot(id);

        dispatch({ type: FETCH, payload: data});
        dispatch({ type: END_LOADING });
    } catch (error) {
        console.log(error);
        dispatch({ type: END_LOADING });
    }


}
